import { render } from "./fieldCustomTextArea.vue?vue&type=template&id=5cd63e68"
import script from "./fieldCustomTextArea.vue?vue&type=script&lang=js"
export * from "./fieldCustomTextArea.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__